
import Vue from 'vue'
import ZoomImage from '../zoom-image/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'ZoomImageList',
  components: {
    ZoomImage
  },
  mixins: [staticBlockMixin],
  methods: {
    fancyfyImage (imageId: number, caption: string) {
      const isSafariBrowser = navigator ? /^(?!.*chrome).*safari/i.test(navigator.userAgent) : false
      const src = imageId ? `${this.$config.API_URL}/image-minifier/v1/${imageId}.${isSafariBrowser ? 'jpg' : 'webp'}?preview=overfull&quality=100&method=CatmullRom&preserveRatio=true&format=${isSafariBrowser ? 'jpg' : 'webp'}` : ''
      const thumb = imageId ? `${this.$config.API_URL}/image-minifier/v1/${imageId}.${isSafariBrowser ? 'jpg' : 'webp'}?preview=thumb&quality=100&method=CatmullRom&preserveRatio=true&format=${isSafariBrowser ? 'jpg' : 'webp'}` : ''
      return {
        src,
        thumb,
        type: 'image',
        caption
      }
    },

    fancyfyImages () {
      return this.blocks.map(block => this.fancyfyImage(block.fields.image?.value, block.fields?.caption?.value))
    },

    chooseImage (startIndex: number) {
      this.$fancybox.show(this.fancyfyImages(), { startIndex, infinite: true, overlayColor: '#fff' })
    }
  }
})
